import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getHomeRouteByRole } from "../../utils/rutas";
import ModificarMensajeAutomatico from "./ModificarMensajeAutomatico";
import TextoCarrito from "./TextoCarrito";
import TextoPublico from "./TextoPublico";
import GestionTestimonios from "./GestionTestimonios";
import TextosLegales from "./TextosLegales";
import DatosFiscalesAcademia from "./DatosFiscalesAcademia";
import ResponsiveActionSidebar from "../../components/ResponsiveActionSidebar";
import { API_URL } from "../../config";
import "./Configuracion.css";

const Configuracion = () => {
  const navigate = useNavigate();
  const [rol, setRol] = useState("");

  useEffect(() => {
    fetch(`${API_URL}/verificar-token`, { credentials: "include" })
      .then((r) => r.json())
      .then((data) => {
        if (data.valid) setRol(data.usuario.rol);
      })
      .catch((err) => console.error("Error obteniendo rol:", err));
  }, []);

  const handleVolver = () => {
    navigate(getHomeRouteByRole(rol), { replace: true });
  };

  const [tab, setTab] = useState("publicidad");
  const [preview, setPreview] = useState("");
  const [archivo, setArchivo] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [msg, setMsg] = useState("");

  // Cargar banner guardado desde la configuración del backend
  useEffect(() => {
    const controller = new AbortController();

    fetch(`${API_URL}/api/configuracion/publicidad-carrito`, {
      credentials: "include",
      signal: controller.signal,
    })
      .then((r) => {
        if (!r.ok) throw new Error("No se pudo cargar la publicidad del carrito");
        return r.json();
      })
      .then((data) => {
        if (data?.publicidadCarrito) setPreview(data.publicidadCarrito);
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.error("Error cargando publicidad del carrito:", err);
        }
      });

    return () => controller.abort();
  }, []);

  const handleFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;

    if (!/^image\/(png|jpe?g|webp|gif)$/i.test(f.type)) {
      setMsg("Formato no soportado. Usa PNG, JPG, WEBP o GIF.");
      return;
    }

    setMsg("");
    setArchivo(f);

    const reader = new FileReader();
    reader.onload = () => setPreview(reader.result);
    reader.readAsDataURL(f);
  };

  const handleGuardar = async () => {
    if (!archivo) {
      setMsg(preview ? "Selecciona una imagen nueva para actualizarla." : "Selecciona una imagen primero.");
      return;
    }

    setGuardando(true);
    setMsg("");

    try {
      const contenidoBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error("No se pudo leer el archivo"));
        reader.readAsDataURL(archivo);
      });

      const resUpload = await fetch(`${API_URL}/subir-imagen-curso`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          nombre: archivo.name,
          tipo: archivo.type,
          contenidoBase64,
        }),
      });

      const dataUpload = await resUpload.json();
      if (!resUpload.ok || !dataUpload?.url) {
        throw new Error(dataUpload?.error || "No se pudo subir la imagen");
      }

      const resSave = await fetch(`${API_URL}/api/configuracion/publicidad-carrito`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ publicidadCarrito: dataUpload.url }),
      });

      const dataSave = await resSave.json();
      if (!resSave.ok) {
        throw new Error(dataSave?.error || "No se pudo guardar la publicidad");
      }

      setPreview(dataUpload.url);
      setArchivo(null);
      setMsg("Publicidad guardada y aplicada al carrito.");
    } catch (err) {
      console.error("Error guardando publicidad del carrito:", err);
      setMsg(err.message || "Error al guardar la publicidad.");
    } finally {
      setGuardando(false);
    }
  };

  const handleQuitar = async () => {
    setGuardando(true);
    setMsg("");

    try {
      const res = await fetch(`${API_URL}/api/configuracion/publicidad-carrito`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ publicidadCarrito: null }),
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data?.error || "No se pudo eliminar la publicidad");
      }

      setPreview("");
      setArchivo(null);
      setMsg("Publicidad eliminada del carrito.");
    } catch (err) {
      console.error("Error eliminando publicidad del carrito:", err);
      setMsg(err.message || "Error al eliminar la publicidad.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="gd-container">
      <div className="gd-main-container">
        
        {/* CONTENIDO */}
        <div className="gd-content">
          <div className="titulo-director">
            <img
              src="/logos/logos_jerarquicos/1.logo_director.png"
              alt="Logo"
              className="logo-director"
            />
            <h1 className="texto-director">CONFIGURACIÓN</h1>
          </div>

          {/* Paneles */}
          {tab === "publicidad" && (
            <section className="cfgx-section">
              <h2>Publicidad del carrito</h2>

              <div className="cfgx-uploader">
                <label htmlFor="bannerFile" className="cfgx-file-label">Seleccionar imagen</label>
                <input id="bannerFile" type="file" accept="image/*" onChange={handleFile} />

                <div className="cfgx-actions">
                  <button className="cfgx-btn-guardar" onClick={handleGuardar} disabled={guardando}>
                    {guardando ? "Guardando..." : "Guardar y aplicar"}
                  </button>
                  <button className="cfgx-btn-quitar" onClick={handleQuitar} disabled={guardando || !preview}>
                    Quitar publicidad
                  </button>
                </div>
              </div>

              <div className="cfgx-preview-card">
                <h4>Vista previa</h4>
                <div className="cfgx-preview-frame">
                  {preview ? (
                    <img src={preview} alt="Vista previa publicidad carrito" />
                  ) : (
                    <div className="cfgx-preview-placeholder">Sin imagen</div>
                  )}
                </div>
              </div>

              {msg && <p className="cfgx-msg">{msg}</p>}
            </section>
          )}

          {tab === "apariencia" && (
            <section className="cfgx-section">
              <h2>Apariencia</h2>
              <p className="cfgx-help">Opciones de tema y colores (próximamente).</p>
            </section>
          )}

          {tab === "mensaje" && <ModificarMensajeAutomatico />}

          {tab === "textoCarrito" && <TextoCarrito />}

          {tab === "textoPublico" && <TextoPublico />}

          {tab === "testimonios" && <GestionTestimonios />}

          {tab === "textosLegales" && <TextosLegales />}

          {tab === "datosFiscales" && <DatosFiscalesAcademia />}

          {tab === "pagos" && (
            <section className="cfgx-section">
              <h2>Pagos</h2>
              <p className="cfgx-help">Configuración de métodos y pasarelas (próximamente).</p>
            </section>
          )}

          {tab === "usuarios" && (
            <section className="cfgx-section">
              <h2>Usuarios</h2>
              <p className="cfgx-help">Preferencias y permisos (próximamente).</p>
            </section>
          )}
        </div>

        {/* SIDEBAR */}
        <ResponsiveActionSidebar
          id="configuracion-sidebar"
          className="gd-sidebar"
          openClassName="gd-sidebar--open"
          ariaLabel="Acciones de configuración"
        >
          <ul className="gd-links">
            <li className="gd-link-item">
              <button
                className={`gd-link ${tab === "publicidad" ? "active" : ""}`}
                onClick={() => setTab("publicidad")}
              >
                Publicidad del carrito
              </button>
            </li>

            <li className="gd-link-item">
              <button
                className={`gd-link ${tab === "apariencia" ? "active" : ""}`}
                onClick={() => setTab("apariencia")}
              >
                Apariencia
              </button>
            </li>

            <li className="gd-link-item">
              {/*<button
                className={`gd-link ${tab === "pagos" ? "active" : ""}`}
                onClick={() => setTab("pagos")}
              >
                Pagos
              </button>
            </li>*/}
                <button
                  className={`gd-link ${tab === "mensaje" ? "active" : ""}`}
                  onClick={() => setTab("mensaje")}
                >
                  Modificar Mensaje Automático
                </button>
                </li>

            <li className="gd-link-item">
              <button
                className={`gd-link ${tab === "textoCarrito" ? "active" : ""}`}
                onClick={() => setTab("textoCarrito")}
              >
                Texto del carrito
              </button>
            </li>

            <li className="gd-link-item">
              <button
                className={`gd-link ${tab === "textoPublico" ? "active" : ""}`}
                onClick={() => setTab("textoPublico")}
              >
                Textos página pública
              </button>
            </li>

            <li className="gd-link-item">
              <button
                className={`gd-link ${tab === "testimonios" ? "active" : ""}`}
                onClick={() => setTab("testimonios")}
              >
                Testimonios
              </button>
            </li>

            <li className="gd-link-item">
              <button
                className={`gd-link ${tab === "textosLegales" ? "active" : ""}`}
                onClick={() => setTab("textosLegales")}
              >
                Textos legales
              </button>
            </li>

            <li className="gd-link-item">
              <button
                className={`gd-link ${tab === "datosFiscales" ? "active" : ""}`}
                onClick={() => setTab("datosFiscales")}
              >
                Datos fiscales de la academia
              </button>
            </li>

            <li className="gd-link-item">
              <button
                className={`gd-link ${tab === "usuarios" ? "active" : ""}`}
                onClick={() => setTab("usuarios")}
              >
                Usuarios
              </button>
            </li>

            {/* ➤ NUEVO BOTÓN SALIR */}
            <li className="gd-link-item">
              <button className="gd-link staff-sidebar-exit-button" onClick={handleVolver}>
                Salir
              </button>
            </li>
          </ul>
        </ResponsiveActionSidebar>
      </div>
    </div>
  );
};

export default Configuracion;
